import urls from '../constants/urls';
import moment from 'moment';
import _ from 'lodash';

export const LOADING_LINES = 'chartsMixpanel/LOADING_LINES';
export const LOAD_LINES_SUCCESS = 'chartsMixpanel/LOAD_LINES_SUCCESS';
export const LOAD_LINES_FAILED = 'chartsMixpanel/LOAD_LINES_FAILED';

export const LOADING_TABLE = 'chartsMixpanel/LOADING_TABLE';
export const LOAD_TABLE_SUCCESS = 'chartsMixpanel/LOAD_TABLE_SUCCESS';
export const LOAD_TABLE_FAILED = 'chartsMixpanel/LOAD_TABLE_FAILED';

const DATE_FORMAT = 'YYYY-MM-DD';

const processLinesData = action => {
  const result = {};
  const { data } = action.payload.data;
  const keys = EVENTS.map(i => i.label);

  const fromDate = action.meta.previousAction.meta.fromDate.clone();
  const toDate = action.meta.previousAction.meta.toDate.clone();

  const datesObject = {};
  while (fromDate <= toDate) {
    datesObject[fromDate.format(DATE_FORMAT)] = 0;
    fromDate.add(1, 'd');
  }

  keys.forEach(key => {
    result[key] = {};
    Object.assign(result[key], datesObject);
  });

  data.forEach(
    event =>
      (result[event.key[0]][moment(event.key[2]).format(DATE_FORMAT)] =
        event.value)
  );

  Object.keys(result).forEach(event => {
    const sum = Object.values(result[event]).reduce((i, c) => i + c, 0);
    const value = sum.toLocaleString();
    result[`${event}Total`] = value;
  });

  return result;
};

const processTableData = action => {
  const result = {};
  let { data } = action.payload.data;

  data = _.orderBy(data, ['value'], ['desc']);
  data = _(data).take(20);
  data.forEach(event => (result[event.key[0]] = event.value));

  return result;
};

const EVENTS = [
  { event: 'Directory', label: 'directoryViewedLine' },
  { event: 'Called external number', label: 'externalCallCreatedLine' },
];

const initialState = {
  lines: {},
  table: {},

  isLoadingLines: false,
  isLoadingTable: false,

  isEmptyLines: false,
  isEmptyTable: false,

  failedLoadingLines: false,
  failedLoadingTable: false,
};

export default (state = initialState, action) => {
  let processedData;

  switch (action.type) {
    case LOADING_LINES:
      return {
        ...state,
        isLoadingLines: true,
        isEmptyLines: false,
        failedLoadingLines: false,
      };

    case LOAD_LINES_SUCCESS:
      processedData = processLinesData(action);

      return {
        ...state,

        isLoadingLines: false,
        isEmptyLines: !processedData,
        failedLoadingLines: false,
        lines: processedData,
      };

    case LOAD_LINES_FAILED:
      return {
        ...state,
        isLoadingLines: false,
        isEmptyLines: false,
        failedLoadingLines: true,
      };

    case LOADING_TABLE:
      return {
        ...state,
        isLoadingTable: true,
        isEmptyTable: false,
        failedLoadingTable: false,
      };

    case LOAD_TABLE_SUCCESS:
      processedData = processTableData(action);

      return {
        ...state,

        isLoadingTable: false,
        isEmptyTable: !processedData,
        failedLoadingTable: false,
        table: processedData,
      };

    case LOAD_TABLE_FAILED:
      return {
        ...state,
        isLoadingTable: false,
        isEmptyTable: false,
        failedLoadingTable: true,
      };

    default:
      return state;
  }
};

export const loadLines = (fromDate, toDate, hospitalId) => dispatch => {
  const fd = fromDate.format(DATE_FORMAT);
  const td = toDate.format(DATE_FORMAT);

  return dispatch({
    types: [LOADING_LINES, LOAD_LINES_SUCCESS, LOAD_LINES_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.hospitals.charts.v3.events(hospitalId),
        params: { from_date: fd, to_date: td, event: 'all' },
      },
    },
    meta: { fromDate, toDate },
  });
};

export const loadTable = (fromDate, toDate, hospitalId) => dispatch => {
  const fd = fromDate.format(DATE_FORMAT);
  const td = toDate.format(DATE_FORMAT);

  return dispatch({
    types: [LOADING_TABLE, LOAD_TABLE_SUCCESS, LOAD_TABLE_FAILED],
    payload: {
      request: {
        method: 'get',
        url: urls.hospitals.charts.v3.events(hospitalId),
        params: { from_date: fd, to_date: td, event: 'guideline_viewed' },
      },
    },
    meta: { fromDate, toDate },
  });
};
